var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRsInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "24/Login/RS Instagram"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.97998 2.77002C4.18506 2.77002 2.72998 4.22509 2.72998 6.02002V18.02C2.72998 19.8149 4.18506 21.27 5.97998 21.27H17.98C19.7749 21.27 21.23 19.8149 21.23 18.02V6.02002C21.23 4.22509 19.7749 2.77002 17.98 2.77002H5.97998ZM1.22998 6.02002C1.22998 3.39667 3.35663 1.27002 5.97998 1.27002H17.98C20.6033 1.27002 22.73 3.39667 22.73 6.02002V18.02C22.73 20.6434 20.6033 22.77 17.98 22.77H5.97998C3.35663 22.77 1.22998 20.6434 1.22998 18.02V6.02002Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.98 8.27002C9.90891 8.27002 8.22998 9.94895 8.22998 12.02C8.22998 14.0911 9.90891 15.77 11.98 15.77C14.051 15.77 15.73 14.0911 15.73 12.02C15.73 9.94895 14.051 8.27002 11.98 8.27002ZM6.72998 12.02C6.72998 9.12052 9.08049 6.77002 11.98 6.77002C14.8795 6.77002 17.23 9.12052 17.23 12.02C17.23 14.9195 14.8795 17.27 11.98 17.27C9.08049 17.27 6.72998 14.9195 6.72998 12.02Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.85 4.65997C19.2642 4.65997 19.6 4.99576 19.6 5.40997V6.40997C19.6 6.82419 19.2642 7.15997 18.85 7.15997C18.4358 7.15997 18.1 6.82419 18.1 6.40997V5.40997C18.1 4.99576 18.4358 4.65997 18.85 4.65997Z",
    fill: "#FFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRsInstagram);
export default __webpack_public_path__ + "static/media/RSInstagram.ee12c38fc6ae007243bcb5b8e7c18f61.svg";
export { ForwardRef as ReactComponent };